import { List, Datagrid, TextField } from "react-admin";
import useDataGridStyles from "../components/DataGridStyle";

import LayoutContainer from "../components/LayoutContainer";
import SfBreadcrumbs from "../../../components/SfBreadcrumbs";
import PermissionChecker from "../../../components/PermissionChecker";
import exporter from "../../../utils/exporter";
import CustomAction from "../components/CustomAction";
import CustomDateField from "../components/CustomDateField";

const BranchList = (props) => {
  const title = "Discount and Special Offers";
  const headers = [
    { label: "Name", source: "name" },
    { label: "Description", source: "desc" },
    { label: "Type", source: "items[0].coupon.type" },
    { label: "Status", source: "status" },
    { label: "Created", source: "time" },
  ];
  const classes = useDataGridStyles();
  return (
    <LayoutContainer>
      <SfBreadcrumbs path="Management/Discount and Special Offers" lower />
      <List
        {...props}
        //filters={<ProductFilter />}
        perPage={10}
        bulkActionButtons={false}
        exporter={(data) => exporter(data, headers, title)}
        actions={<CustomAction labelCreate="Add Special Offers" />}
        classes={{ content: classes.content }}
      >
        <Datagrid
          rowClick="show"
          classes={{ headerCell: classes.header, rowCell: classes.row }}
        >
          <TextField label="Name" source="name" />
          <TextField label="Description" source="desc" />
          <TextField label="Type" source="items[0].coupon.type" />
          <TextField label="Status" source="status" />
          <CustomDateField label="Created" source="time" />
        </Datagrid>
      </List>
      <PermissionChecker code="Page.Merchant.Management.Offer" />
    </LayoutContainer>
  );
};

export default BranchList;
